import api from "../config/api";

export const createNewUser = async (payload, contactId) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  const { data } = await api.post(
    encodeURI(
      `/tenancy/clients/${clientCognitoId}/user_signup?from_contact_id=${contactId}`
    ),
    payload
  );

  return data?.data;
};

export const adminSignUp = async ({ apiKey, clientId, ...payload }) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  if (!clientId) {
    throw new Error("Client ID missing");
  }

  const { data } = await api.post(
    encodeURI(`/tenancy/clients/${clientId}/admin_signup/${apiKey}`),
    { ...payload, platform_client_id: clientId }
  );

  return data;
};

export const clientSignUp = async ({ apiKey, ...payload }) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  const { data } = await api.post(
    encodeURI(`tenancy/clients/register_commercial_user`),
    {
      ...payload,
      platform_client_id: clientCognitoId,
    }
  );

  return data;
};

export const getTenancyInfo = async (userId) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  const { data } = await api.get(
    `/tenancy/clients/${clientCognitoId}?user_id=${userId}`
  );

  return data;
};

export const updateTenancyInfo = async (payload) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  const { data } = await api.patch(
    `/tenancy/clients/${clientCognitoId}`,
    payload
  );

  return data;
};

export const getClientRegistrationData = async ({
  platformId,
  registrationId,
}) => {
  if (!platformId) {
    throw new Error("It was not possible to identify the platform.");
  }

  if (!registrationId) {
    throw new Error("RegistrationId is required");
  }

  const { data } = await api.get(
    `/tenancy/clients/${platformId}/registration/${registrationId}`
  );

  return data;
};

export const getPlatformUsers = async ({ userId, userType }) => {
  if (!userId) {
    throw new Error("User ID missing.");
  }

  const userTypes = ["owner", "admin", "customer"];
  const query =
    userType && userTypes.includes(userType) ? `?user_type=${userType}` : "";
  const { data } = await api.get(`/tenancy/clients/${userId}/users${query}`);

  return data;
};

export const getPlatformUser = async ({ userId, clientId }) => {
  if (!userId) {
    throw new Error("User ID missing.");
  }

  if (!clientId) {
    throw new Error("Client ID missing.");
  }

  const { data } = await api.get(
    `/tenancy/clients/${clientId}/users/${userId}`
  );

  return data;
};

export const sendAdminInvite = async (clientId, payload) => {
  const { data } = await api.post(`/tenancy/clients/admin_invite`, {
    ...payload,
    platform_client_id: clientId,
  });

  return data;
};

export const getAuthUsers = async ({ clientId }) => {
  if (!clientId) {
    throw new Error("Client ID missing.");
  }

  const { data } = await api.get(`/tenancy/clients/${clientId}/auth_users`);

  return data;
};

export const sendAuthUserInvite = async (clientId, payload) => {
  const { data } = await api.post(
    `/tenancy/clients/${clientId}/auth_users/invite`,
    payload
  );

  return data;
};

export const authUserApplication = async (userId, payload) => {
  const { data } = await api.post(
    `/tenancy/clients/auth_users/${userId}`,
    payload
  );
  return data;
};

export const deleteAdmin = async ({ email, userId, clientId }) => {
  if (!userId) {
    throw new Error("User ID missing.");
  }

  if (!clientId) {
    throw new Error("Client ID missing.");
  }

  if (!email) {
    throw new Error("Email missing.");
  }

  await api.post(
    `/auth/sign_out/${clientId}/${email}?global_sign_out=true`,
    {}
  );

  const { data } = await api.delete(`/tenancy/clients/${clientId}/${userId}`);

  return data;
};

export const deleteAuthUser = async ({ email, userId, clientId }) => {
  if (!userId) {
    throw new Error("User ID missing.");
  }

  if (!clientId) {
    throw new Error("Client ID missing.");
  }

  const { data } = await api.delete(
    `/tenancy/clients/${clientId}/auth_users/${userId}`
  );
  return data;
};

export const demoteAuthUser = async ({ userId, clientId }) => {
  if (!userId) {
    throw new Error("User ID missing.");
  }

  if (!clientId) {
    throw new Error("Client ID missing.");
  }

  const { data } = await api.patch(
    `/tenancy/clients/${clientId}/auth_users/${userId}`,
    {}
  );
  return data;
};
